export default "__VITE_ASSET__nPuv8Dkj__"